module.exports = __webpack_public_path__ + "img/24.4adb4ef5.png";